// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.uuid(),
  ttwPage: __t.uuid().name("ttw_page"),
  transactOfferingId: __t.option(__t.string()).name("transact_offering_id"),
  name: __t.string(),
  status: __t.string(),
  targetAmountCents: __t.i64().name("target_amount_cents"),
  maxAmountCents: __t.i64().name("max_amount_cents"),
  minCheckSizeCents: __t.i64().name("min_check_size_cents"),
  startDateMs: __t.i64().name("start_date_ms"),
  endDateMs: __t.i64().name("end_date_ms"),
  maxPerInvestorCents: __t.option(__t.i64()).name("max_per_investor_cents"),
  transactStatus: __t.option(__t.string()).name("transact_status"),
});
